import {isEmpty} from './validation';

export const printInNewTab = function(html, title = null){

    html = `<div class="jre-report-container" > ${html} </div>`;

    if(isEmpty(title) || title === null || title === ''){
        if(html.indexOf('<h1', 0) > 0) {
            const end = html.indexOf('</h1>', 0);
            let start = html.indexOf('<h1', 0);
            start = html.indexOf('>', start);
            title = html.substring(start+1, end);
        }
        if(isEmpty(title) || title === null || title === ''){
            if(html.indexOf('<h2', 0) > 0) {
                const end = html.indexOf('</h1>', 0);
                let start = html.indexOf('<h2', 0);
                start = html.indexOf('>', start);
                title = html.substring(start+1, end);
            }
        }
    }
    else {
        title = 'JRE - JavaScript Rendering Engine';
    }

    let mywindow = window.open();
    mywindow.document.write(`<html><head><title>${title}</title>`);

    for (const node of document.querySelectorAll('head > link[rel="stylesheet"]')) {
        mywindow.document.write('<link rel="stylesheet" href="' + node.getAttribute('href') +  '"  />');
    }
    for (const node of document.querySelectorAll('head > link[rel="stylesheet"]')) {
        mywindow.document.write('<link rel="stylesheet" href="' + node.getAttribute('href') +  '"  />');
    }
    mywindow.document.write('</head><body >');
    mywindow.document.write(html);
    mywindow.document.write('');
    mywindow.document.write('</body></html>');
    setTimeout(function() {
        mywindow.document.close();
        mywindow.focus();
        mywindow.print();
        mywindow.close();
    }, 750); // necessary for Chrome print preview
};



// WEBPACK FOOTER //
// ./src/js/utilities/print.js